<template>
    <div class="card">
        <TabView>
            <TabPanel header="ข้อมูลพื้นฐานระบบ">
                <system-general></system-general>
            </TabPanel>
            <TabPanel header="ข้อมูลจังหวัด, อำเภอ, ตำบล">
                <system-country></system-country>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import systemGeneral from './InformationGeneral';
import systemCountry from './InformationCountry';

export default {
    components: {
        systemGeneral,
        systemCountry
    },
    data() {
      return{
      }    
    },
    created(){
    },

    mounted(){

    },

    watch:{
       
    },
    computed: {

    }
}
</script>